import { render, staticRenderFns } from "./CheckoutFooter.vue?vue&type=template&id=f5612238"
import script from "./CheckoutFooter.vue?vue&type=script&lang=js"
export * from "./CheckoutFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports